
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/article/[id]",
      function () {
        return require("private-next-pages/blog/article/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/article/[id]"])
      });
    }
  